module.exports = {
    "dismiss": `Revocare`
};


//# sourceMappingURL=ro-RO.main.js.map
